<template>
    <div style="width:100%;height:100%;">
        <div class="map" id="map">
        </div>
    </div>
</template>

<script>
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import {
    tiandituTileLayer
} from '@supermap/iclient-leaflet'

import {tiledMapLayer} from '@supermap/iclient-leaflet'
export default {
    props:{
        initId:{
            type:String,
            default:'map'
        },
        collections: {
            type: Array
        },
        areaBox:{
            type:Array,
            default: () => []
        },
    },
    data(){
        return{
            baseMap:null,
            AllCollection:[],
            version:0,
            timer:null,
            startTime:'',
            endTime:'',
            nowTime:'',
            TimeLayerGroup:null,
            lalayerIDlist:[],
            timeList:[],
            layerIndex: 0,
            isFirst:true,
            initUrl:'',
        }
    },
    watch:{
    },
    destroyed(){
    },
    methods:{
        initMap(){
            const crsBaseMap = this.collections[0].baseUnderUrl
            var url = initmapUlr+this.collections[0].underPaintingUrl
            switch (crsBaseMap) {
                case '3995':
                    this.baseMap = L.map(this.initId, {
                        crs: L.CRS.NonEarthCRS({
                            bounds: L.bounds([-45888490.52,-47298112.34], [45888490.52, 45888490.52]),
                            origin: L.point(-45888490.52,45888490.52)
                        }),
                        center: [733210.56 , -1230428.86],
                        maxZoom: 18,
                        zoomControl:false,
                        attributionControl:false,
                        zoom: 1,
                    });
                    tiledMapLayer(url,{
                        noWrap:true
                    }).addTo(this.baseMap);
                    break;
                case '3413':
                    
                    this.baseMap = L.map(this.initId, {
                        crs: L.CRS.NonEarthCRS({
                            bounds: L.bounds([-45751178.11 , -45751178.11], [45751178.11 , 45751178.11]),
                            origin: L.point( -45751178.11,45751178.11 )
                        }),
                        center: [0,0],
                        maxZoom: 18,
                        zoomControl:false,
                        attributionControl:false,
                        zoom: 1,
                    });
                    tiledMapLayer(url,{
                        noWrap:true
                    }).addTo(this.baseMap);
                    break;
                case '4326':
                    this.baseMap = L.map(this.initId, {
                        crs: L.CRS.TianDiTu_WGS84,
                        center: [35,70],
                        maxZoom: 18,
                        zoomControl:false,
                        attributionControl:false,
                        zoom: 0,
                    });
                    tiandituTileLayer({
                        layerType: 'img',
                        key: 'bb11a33c4377f10603478ed166691455'
                    })
                    .addTo(this.baseMap);
                  if (!this.isEnglish) {
                    tiandituTileLayer({
                      layerType: 'img',
                      isLabel: true,
                      key: '73ae12883e85f0abe62f8941835a4129',
                      noWrap: false,
                    })
                        .addTo(this.baseMap);
                  } else {
                    tiandituTileLayer({
                      url: 'http://t0.tianditu.gov.cn/eia_c/wmts?&layer=eia&',
                      layerType: 'img',
                      isLabel: true,
                      key: '73ae12883e85f0abe62f8941835a4129'
                    })
                        .addTo(this.baseMap);
                  }
                    break;
                case '6931':
                    this.baseMap = L.map(this.initId, {
                        center: [0,0],
                        maxZoom: 18,
                        crs: L.CRS.NonEarthCRS({
                            bounds: L.bounds([ -12304634.27 , -12304634.27 ], [12304634.27 , 12304634.27]),
                            origin: L.point( -12304634.27 ,12304634.27 )
                        }),
                        zoomControl:false,
                        attributionControl:false,
                        zoom: 1,
                    });
                    tiledMapLayer(url,{
                        noWrap:true
                    }).addTo(this.baseMap);
                    break;
                case '3031':
                    this.baseMap = L.map(this.initId, {
                        center: [0,0],
                        maxZoom: 18,
                        crs: L.CRS.NonEarthCRS({
                            bounds: L.bounds([-196813683.09 , -100120990.38], [160561879.38 , 191038276.28]),
                            origin: L.point(-196813683.09 ,160561879.38)
                        }),
                        zoomControl:false,
                        attributionControl:false,
                        zoom: 1,
                    });
                    tiledMapLayer(url,{
                        noWrap:true
                    }).addTo(this.baseMap);
                    break;
            }
            this.TimeLayerGroup = L.layerGroup().addTo(this.baseMap);
            this.addAllArea(this.areaBox)
        },
        addAllArea(arrs){
            console.log('范围',arrs);
            var polygon = L.polygon(arrs, {color: 'red',fill:false});
            this.TimeLayerGroup.addLayer(polygon)
            this.baseMap.fitBounds(polygon.getBounds());
        },
    },
    
    created(){
    },
    mounted(){
      const language = window.localStorage.getItem('language')
      if (language === 'zh') {
        this.isEnglish = false
      }
      if (language === 'en') {
        this.isEnglish = true
      }
        this.initMap()
    }
}
</script>

<style lang="scss" scoped>
.map{
    width: 100%;
    height: 100%;
}
/deep/.iclient-leaflet-logo{
    display: none;
}
</style>
